function getCookie(name) {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return decodeURIComponent(arr[2])
  } else {
    return null
  }
}

function setCookie(name, value, days) {
  let cpUrl = window.ConfigNew.cpUrl
  let zy = window.location.host.split('.').reverse()
  let cp = cpUrl
    .replace(/(http|https):\/\/([^/]*)\//g, '$2')
    .split('.')
    .reverse()
  let lgt = Math.min(zy.length, cp.length)
  let _domain = ''

  for (var i = 0; i < lgt; i++) {
    if (zy[i] === cp[i]) {
      _domain = '.' + zy[i] + _domain
    } else {
      break
    }
  }

  let expires
  var date = new Date()
  date.setTime(date.getTime() + (days || 30) * 24 * 60 * 60 * 1000)
  expires = '; expires=' + date.toGMTString()

  document.cookie = name + '=' + value + expires + '; path=/;domain=' + _domain
}

const $cookie = {
  get: getCookie,
  set: setCookie
}

export { $cookie }

export function trim(text) {
  return text.replace(/(^\s+)|(\s+$)/g, '')
}

export function getBrowserInfo() {
  var Sys = {}
  var ua = navigator.userAgent.toLowerCase()
  var s

  if (ua.match(/rv:([\d.]+)/)) {
    s = ua.match(/rv:([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/msie ([\d.]+)/)) {
    s = ua.match(/msie ([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/trident\/([\d.]+)/)) {
    s = ua.match(/trident\/([\d.]+)/)
    Sys.ie = s[1]
  } else if (ua.match(/firefox\/([\d.]+)/)) {
    s = ua.match(/firefox\/([\d.]+)/)
    Sys.firefox = s[1]
  } else if (ua.match(/chrome\/([\d.]+)/)) {
    s = ua.match(/chrome\/([\d.]+)/)
    Sys.chrome = s[1]
  } else if (ua.match(/opera.([\d.]+)/)) {
    s = ua.match(/opera.([\d.]+)/)
    Sys.opera = s[1]
  } else if (ua.match(/version\/([\d.]+).*safari/)) {
    s = ua.match(/version\/([\d.]+).*safari/)
    Sys.safari = s[1]
  }

  if (Sys.ie) {
    Sys.name = 'IE'
    Sys.version = Sys.ie
  } else if (Sys.firefox) {
    Sys.name = 'Firefox'
    Sys.version = Sys.firefox
  } else if (Sys.chrome) {
    Sys.name = 'Chrome'
    Sys.version = Sys.chrome
  } else if (Sys.opera) {
    Sys.name = 'Opera'
    Sys.version = Sys.opera
  } else if (Sys.safari) {
    Sys.name = 'Safari'
    Sys.version = Sys.safari
  }

  return Sys
}
export function getBrowserInfoPlus() {
  var document = window.document
  var navigator = window.navigator
  var agent = navigator.userAgent.toLowerCase()
  // IE8+支持.返回浏览器渲染当前文档所用的模式
  // IE6,IE7:undefined.IE8:8(兼容模式返回7).IE9:9(兼容模式返回7||8)
  // IE10:10(兼容模式7||8||9)
  var IEMode = document.documentMode
  // chorme
  var chrome = window.chrome || false
  var System = {
    // user-agent
    agent: agent,
    // 是否为IE
    isIE: /msie/.test(agent),
    // Gecko内核
    isGecko: agent.indexOf('gecko') > 0 && agent.indexOf('like gecko') < 0,
    // webkit内核
    isWebkit: agent.indexOf('webkit') > 0,
    // 是否为标准模式
    isStrict: document.compatMode === 'CSS1Compat',
    // 是否支持subtitle
    supportSubTitle: function() {
      return 'track' in document.createElement('track')
    },
    // 是否支持scoped
    supportScope: function() {
      return 'scoped' in document.createElement('style')
    },
    // 获取IE的版本号
    ieVersion: function() {
      try {
        return agent.match(/msie ([\d.]+)/)[1] || 0
      } catch (e) {
        console.log('error')
        return IEMode
      }
    },
    // Opera版本号
    operaVersion: function() {
      try {
        if (window.opera) {
          return agent.match(/opera.([\d.]+)/)[1]
        } else if (agent.indexOf('opr') > 0) {
          return agent.match(/opr\/([\d.]+)/)[1]
        }
      } catch (e) {
        console.log('error')
        return 0
      }
    },
    _mime: function(option, value) {
      var mimeTypes = navigator.mimeTypes
      for (var mt in mimeTypes) {
        if (mimeTypes[mt][option] === value) {
          return true
        }
      }
      return false
    },
    // 描述:version过滤.如31.0.252.152 只保留31.0
    versionFilter: function() {
      if (arguments.length === 1 && typeof arguments[0] === 'string') {
        var version = arguments[0]
        var start = version.indexOf('.')
        if (start > 0) {
          var end = version.indexOf('.', start + 1)
          if (end !== -1) {
            return version.substr(0, end)
          }
        }
        return version
      } else if (arguments.length === 1) {
        return arguments[0]
      }
      return 0
    }
  }

  try {
    // 浏览器类型(IE、Opera、Chrome、Safari、Firefox)
    System.type = System.isIE
      ? 'IE'
      : window.opera || agent.indexOf('opr') > 0
      ? 'Opera'
      : agent.indexOf('chrome') > 0
      ? 'Chrome'
      : window.openDatabase
      ? 'Safari'
      : agent.indexOf('firefox') > 0
      ? 'Firefox'
      : 'unknow'

    // 版本号
    System.version =
      System.type === 'IE'
        ? System.ieVersion()
        : System.type === 'Firefox'
        ? agent.match(/firefox\/([\d.]+)/)[1]
        : System.type === 'Chrome'
        ? agent.match(/chrome\/([\d.]+)/)[1]
        : System.type === 'Opera'
        ? System.operaVersion()
        : System.type === 'Safari'
        ? agent.match(/version\/([\d.]+)/)[1]
        : '0'

    // 浏览器外壳
    System.shell = function() {
      // 遨游浏览器
      if (agent.indexOf('maxthon') > 0) {
        System.version = agent.match(/maxthon\/([\d.]+)/)[1] || System.version
        return '傲游浏览器'
      }
      // QQ浏览器
      if (agent.indexOf('qqbrowser') > 0) {
        System.version = agent.match(/qqbrowser\/([\d.]+)/)[1] || System.version
        return 'QQ浏览器'
      }

      // 搜狗浏览器
      if (agent.indexOf('se 2.x') > 0) {
        return '搜狗浏览器'
      }

      // Chrome:也可以使用window.chrome && window.chrome.webstore判断
      if (chrome && System.type !== 'Opera') {
        var external = window.external

        // 猎豹浏览器:或者agent.indexOf("lbbrowser")>0
        if (external && 'LiebaoGetVersion' in external) {
          return '猎豹浏览器'
        }
        // 百度浏览器
        if (agent.indexOf('bidubrowser') > 0) {
          System.version =
            agent.match(/bidubrowser\/([\d.]+)/)[1] || agent.match(/chrome\/([\d.]+)/)[1]
          return '百度浏览器'
        }
        // 360极速浏览器和360安全浏览器
        if (System._mime('type', 'application/vnd.chromium.remoting-viewer')) {
          // object.key()返回一个数组.包含可枚举属性和方法名称
          var storeKeyLen = Object.keys(chrome.webstore).length
          // var v8Locale = 'v8Locale' in window
          return storeKeyLen > 1 ? '360极速浏览器' : '360安全浏览器'
        }
        return 'Chrome'
      }
      return System.type
    }

    // 浏览器名称(如果是壳浏览器,则返回壳名称)
    System.name = System.shell()
    // 对版本号进行过滤过处理
    System.version = System.versionFilter(System.version)
  } catch (e) {
    console.log('error')
  }
  return {
    client: System
  }
}



// WEBPACK FOOTER //
// ./src/util/Util.js